import { render, staticRenderFns } from "./ProductPromotion.vue?vue&type=template&id=2869191d&scoped=true"
import script from "./ProductPromotion.vue?vue&type=script&lang=js"
export * from "./ProductPromotion.vue?vue&type=script&lang=js"
import style0 from "./ProductPromotion.vue?vue&type=style&index=0&id=2869191d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2869191d",
  null
  
)

export default component.exports